module.exports = __webpack_public_path__ + "static/media/WebsiteDevelopment.f1bcffe7.png";